export default __webpack_public_path__ + "static/biophilia-icon-715f5376d2fc8cd68205451b76fdd05f.png";